import { getLeFEOrigin } from '@utils/util';

export const BohriumProject = () => (
    <iframe className="admin-iframe" title="项目列表" src={`${getLeFEOrigin()}/#/runtime/admin/bohrium_project_list`} />
);
